import { render, staticRenderFns } from "./wxAuth.vue?vue&type=template&id=42e7cf8e"
import script from "./wxAuth.vue?vue&type=script&lang=js"
export * from "./wxAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports